/*
 * VUEX getters
 */
export const adminGetters = {
  isLoggedIn(state) {
    return state.loggedIn
  },
  getLoggedIn(state) {
    return state.loggedIn
  },
  isFeideLoggedIn(state) {
    return state.feideLoggedIn
  },
  getFeideLoggedIn(state) {
    return state.feideLoggedIn
  },
  getLoginInformation(state) {
    return state.logininformation
  },
  getLang(state) {
    return state.language
  },
  getEnvironment(state) {
    return state.environment
  },
  getActiveNavItem(state) {
    return this.activenavitem
  },
  getLanguageCodes(state) {
    return state.languagecodes
  },
  getLanguageCodesMap(state) {
    let codes = state.languagecodes
    if (state.langCodesMap.size > 0) {
      return state.langCodesMap
    } else {
      for (let i = 0; i < codes.length; i++) {
        let lang = codes[i]
        //    console.log('LANG (%J)', lang)
        state.langCodesMap.set(lang.code, lang.langname)
      }
      return state.langCodesMap
    }
  },
  getSiteLanguage(state) {
    return state.sitelanguage
  },
  getTranslationMap(state) {
    return state.translationMap
  },
  getAccessToken(state) {
    return state.accessToken
  },
  getIdToken(state) {
    return state.idToken
  },
  getServerAccesToken(state) {
    return state.serverAccessToken
  },
  getRefreshToken(state) {
    return state.refreshToken
  },
  getLogInProcess(state) {
    return state.loginProcess
  },
  getCallback(state) {
    return state.callback
  },
  getCallbackState(state) {
    return state.callbackstate
  },
  getLicense(state) {
    return state.license
  },
  getDisplayName(state) {
    return state.displayname
  },
  getAffiliation(state) {
    return state.affiliation
  },
  getPicture(state) {
    return state.picture
  },
  getSid(state) {
    return state.sid
  },
  getServerAccessToken(state) {
    return state.serveraccesstoken
  },
  getPublicKey(state) {
    return state.publickey
  },
  getAppSecret(state) {
    return state.appsecret
  }
}
